// buttonDelayEnable.js
var ButtonDelayEnable = pc.createScript('buttonDelayEnable');

var btnSelf;
// initialize code called once per entity
ButtonDelayEnable.prototype.initialize = function() {
    
    btnSelf = this;

    setTimeout(function () {
        btnSelf.entity.children[1].enabled = true;
    }, 2500, this);
};


